import { NewsletterSignupProps } from '@components/modules/NewsletterSignup/NewsletterSignup'
import { selectCountry, selectFooter } from '@redux/globalSlice'
import { openModalView } from '@redux/modalSlice'

import cn from 'clsx'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TrustedHtml from '../TrustedHtml/TrustedHtml'
import MenuList from './MenuList/MenuList'
import Signup from './Signup/Signup'
import styles from './footer.module.scss'

export type FooterProps = {
  copyright: string
} & NewsletterSignupProps

const Footer: FC = () => {
  const { menus, copyright, ...args } = useSelector(selectFooter)
  const country = useSelector(selectCountry)
  const dispatch = useDispatch()

  return (
    <div className={cn(styles.root)} data-elastic-exclude>
      <div className="2xl:container 2xl:my-7">
        <div className="flex flex-wrap">
          <div className={styles.menu}>
            {menus?.map((menuList) => {
              //@ts-ignore
              return <MenuList menuList={menuList} key={menuList.headerTitle} />
            })}
          </div>
          <div className={styles.signup}>
            {/* @ts-ignore */}
            <Signup
              signUpForNewsletter={false}
              newsletterConsentMessage=""
              pressCheckboxLabel=""
              enablePressSignup={false}
              fields={[]}
              source="web footer gubi"
              {...args}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row mt-8 2xl:container 2xl:my-7 relative justify-end items-center bodyText">
        <div className="flex-1"></div>
        <div className={cn(styles.copyRight, 'bodyText')}>
          <TrustedHtml html={copyright} />
        </div>
        <div className="flex items-center justify-end  flex-1 mt-8 lg:mt-0 ">
          <button
            title="select country"
            type="button"
            className="flex items-center cursor-pointer"
            onClick={() => dispatch(openModalView('MARKET_SELECTION'))}
          >
            Country:
            <img
              className="pl-2 cursor-pointer"
              style={{ width: '26px', height: '100%' }}
              src={`https://media.gubi.com/countries/${country?.code.toUpperCase()}.svg`}
              alt={country?.name}
            />
          </button>
        </div>
      </div>
    </div>
  )
}

Footer.displayName = 'Footer'

export default Footer
